import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	MenuList,
	MenuListItem,
	MenuSection,
	MenuSectionHeading,
} from '@atlassian/navigation-system';
import { MENU_ID_PROJECTS_VIEW_ALL_STARRED } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { expVal } from '@atlassian/jira-feature-experiments';
import messages from '../messages.tsx';
import type { FavoriteItemsType } from '../types.tsx';

const VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';

export const RenderStarredSection = componentWithCondition(
	() => expVal('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
	StarredSectionWithFocusRestoration,
	StarredSection,
);

function StarredSectionWithFocusRestoration({
	favoriteItems,
}: {
	favoriteItems: FavoriteItemsType;
}) {
	const { formatMessage } = useIntl();

	// Will implement focus restoration logic in next PR

	return (
		favoriteItems.hasItems && (
			<>
				<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section">
					<MenuSection>
						<MenuSectionHeading>{formatMessage(messages.starred)}</MenuSectionHeading>
						<MenuList>{favoriteItems.list}</MenuList>
					</MenuSection>
				</MenuListItem>
				{favoriteItems.hasNextPage && (
					<Nav4MenuLinkItem href={VIEW_ALL_STARRED_HREF} menuId={MENU_ID_PROJECTS_VIEW_ALL_STARRED}>
						{formatMessage(messages.viewAllStarred)}
					</Nav4MenuLinkItem>
				)}
			</>
		)
	);
}

function StarredSection({ favoriteItems }: { favoriteItems: FavoriteItemsType }) {
	const { formatMessage } = useIntl();

	return (
		favoriteItems.hasItems && (
			<>
				<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section">
					<MenuSection>
						<MenuSectionHeading>{formatMessage(messages.starred)}</MenuSectionHeading>
						<MenuList>{favoriteItems.list}</MenuList>
					</MenuSection>
				</MenuListItem>
				{favoriteItems.hasNextPage && (
					<Nav4MenuLinkItem href={VIEW_ALL_STARRED_HREF} menuId={MENU_ID_PROJECTS_VIEW_ALL_STARRED}>
						{formatMessage(messages.viewAllStarred)}
					</Nav4MenuLinkItem>
				)}
			</>
		)
	);
}
